import type { SelectOptionType } from '~/presentation/reports/ui/type';

export enum IRMetricKey {
  SESSION = 'sessions',
  ORDERS = 'orders',
  PAGE_VIEWS = 'pageviews',
  VISITORS = 'visitors',
  BOUNCE_RATE = 'bounce_rate',
  CTR = 'ctr',
  CONVERSION_RATE = 'conversion_rate',
  AVG_TIME_ON_PAGE = 'average_time_on_page',
  ADDED_TO_CART = 'added_to_cart',
  ADD_TO_CART_RATE = 'added_to_cart_rate',
  REACHED_CHECKOUT = 'sessions_that_reached_checkout',
  COMPLETE_CHECKOUT = 'sessions_that_completed_checkout',
  CART_ADDITION = 'sessions_with_cart_additions',
  AOV = 'aov',
  REVENUE = 'revenue',
  RPV = 'revenue_per_visitor',
  SESSION_BY_DEVICE_TYPE = 'device',
  SESSION_BY_TRAFFIC_SOURCE = 'traffic_source',
  VISITOR_BY_TYPE = 'visitor_type',
}

/**
 * Bounce rate is a "lower is better" metric. Compared against the enum member
 * (not a string) so renaming/removing BOUNCE_RATE is a compile error here,
 * not a silently-broken color.
 */
export const isReverseReportMetric = (metricKey?: IRMetricKey): boolean => {
  return metricKey === IRMetricKey.BOUNCE_RATE;
};

export type RMetricGroupItem = {
  title: string;
  options: SelectOptionType[];
};
export type RMetricGroupType = RMetricGroupItem[];
